import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CookieIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cookie"}/>
}
